import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatiqCellHeaderSortByType, IDatiqCellHeaderSort } from './models';
import {
    DatiqCellHeaderEventsService,
    DatiqCellHeaderService,
} from './services';
import { IDatiqAnalyticsEvent } from '@dat/datiq-core/models';

@Component({
    selector: 'datiq-cell-header-sort',
    templateUrl: './datiq-cell-header-sort.component.html',
    styleUrls: ['./datiq-cell-header-sort.component.scss'],
})
export class DatiqCellHeaderSortComponent implements OnInit {
    @Input()
    settings: IDatiqCellHeaderSort;
    @Output()
    toggled: EventEmitter<IDatiqCellHeaderSort> =
        new EventEmitter<IDatiqCellHeaderSort>();
    @Output()
    toggledOption: EventEmitter<IDatiqAnalyticsEvent> =
        new EventEmitter<IDatiqAnalyticsEvent>();

    typeIsVisualization: boolean;

    constructor(
        private _service: DatiqCellHeaderService,
        private _events: DatiqCellHeaderEventsService
    ) {}

    ngOnInit(): void {
        this.typeIsVisualization =
            this.settings.type === DatiqCellHeaderSortByType.Visualization;
    }

    toggle() {
        this.settings = this._service.toggleSortBy(this.settings);
        this.toggled.emit(this.settings);
        this.toggleOptions();
    }

    toggleOptions(): void {
        const analyticsEvent: IDatiqAnalyticsEvent =
            this._events.getAnalyticsToggledOptionItem(this.settings);
        this.toggledOption.emit(analyticsEvent);
    }
}
